import React from "react"
import { Container } from "react-bootstrap"
import {
  pageIncrement,
  pageDecrement,
  updateClickedNext,
  resetSelectDocument,
  controlLoading,
  controlDeclaration,
  removeChosenedBenefit,
} from "../../redux/actions"
import {
  pleaseAgreeAlert,
  missingProvideBenefitDocumentAlert,
  atLeastUploadOneFileAlert,
} from "../../services/sweetalertService"
import { useDispatch, batch, useSelector } from "react-redux"
import SubmitClaim from "../pages/submitClaim"
import * as API from "../../services/httpService"
import Swal from "sweetalert2"
import NumberFormat from "react-number-format"
import * as Constants from "../../common/constants"

const FunctionalFooter = ({ pageNumber, uiData, claimData }) => {
  const dispatch = useDispatch()

  const {
    claimUploadListModel,
    proofDocuments,
    isEditUpload,
    tempBenefitInfo,
  } = uiData

  const chosenedBenefits = useSelector(state => state.uiData.chosenedBenefits)

  const currentCoverageDetailId = tempBenefitInfo.CoverageDetailId

  const ClearDataWarning = Swal.mixin({
    customClass: {
      confirmButton: "swal-button--back",
      cancelButton: "swal-button--next",
      actions: "swal-footer",
    },
    buttonsStyling: false,
  })

  const checkAtLeastUploadedOneFile = () => {
    // console.log(claimUploadListModel)

    return claimUploadListModel.filter(
      x => x.coverageDetailId === currentCoverageDetailId
    ).length > 0
      ? true
      : false
  }

  const checkMandatoryUploadDocument = () => {
    let mandatoryList = []

    mandatoryList = proofDocuments.filter(x => x.mandatory)

    const currentCoverageUploadList = claimUploadListModel.filter(
      x => x.coverageDetailId === currentCoverageDetailId
    )

    let isUploaded = false

    //reversed for loop, because splice function inside loop
    for (let i = mandatoryList.length - 1; i >= 0; --i) {
      isUploaded = false
      currentCoverageUploadList.forEach(
        (currentCoverageItem, currentCoverageKey) => {
          if (
            !isUploaded &&
            mandatoryList[i].documentId === currentCoverageItem.documentId
          ) {
            mandatoryList.splice(i, 1)
            isUploaded = true
          }
        }
      )
    }
    //If mandatoryList is empty will pass mandatory file validation
    return mandatoryList.length < 1 ? true : false
  }

  const nextPage = () => {
    //reset select document list everytime we click next
    // dispatch(resetSelectDocument())
    switch (pageNumber) {
      case Constants.policyInfoPageNumber:
        dispatch(updateClickedNext(pageNumber, true))
        break

      case Constants.benefitRequiredDocumentPageNumber:
        if (
          !checkMandatoryUploadDocument() &&
          process.env.NODE_ENV !== "development"
        ) {
          missingProvideBenefitDocumentAlert()
        } else {
          if (
            checkAtLeastUploadedOneFile() ||
            process.env.NODE_ENV === "development"
          ) {
            dispatch(resetSelectDocument())
            dispatch(pageIncrement())
          } else {
            atLeastUploadOneFileAlert()
          }
        }
        break

      case Constants.benefitFormPageNumber:
        dispatch(updateClickedNext(pageNumber, true))
        break

      case Constants.reviewPageNumber:
        if (!uiData.showDeclaration) {
          dispatch(updateClickedNext(pageNumber, true))
        } else {
          if (!uiData.checkBoxStatus.isAgree) {
            pleaseAgreeAlert()
          } else {
            dispatch(controlLoading())
            SubmitClaim(dispatch, uiData, claimData)
          }
        }
        break
      default:
        batch(() => {
          dispatch(pageIncrement())
        })
    }
  }

  const previousPage = () => {
    switch (pageNumber) {
      case Constants.policyInfoPageNumber:
        break

      case Constants.benefitGroupPageNumber:
        ClearDataWarning.fire({
          title:
            "Are you sure you want to go back to the first page? This will be remove all the data you have entered.",
          //icon: "warning",
          scrollbarPadding: false,
          showCancelButton: true,
          confirmButtonColor: "#ff3333",
          cancelButtonColor: "#fff",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          focusConfirm: false,
        }).then(result => {
          if (result.value) {
            let deleteMultipleFileArray = []

            claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
              let deleteFileInfo = {}
              deleteFileInfo.fName = UploadedItem.fileName
              deleteFileInfo.folderName = uiData.folderName
              deleteMultipleFileArray.push(deleteFileInfo)
            })

            API.apiPostRequest(
              "/Claim/ClaimDocsMultipleDelete",
              deleteMultipleFileArray,
              null
            ).then(response => {})
            dispatch(pageDecrement())
          }
          return false
        })
        break

      case Constants.benefitRequiredDocumentPageNumber:
        if (
          chosenedBenefits.filter(
            x => x.CoverageDetailId === tempBenefitInfo.CoverageDetailId
          ).length !== 0
        ) {
          if (
            !checkMandatoryUploadDocument()
            // This part moved to checkAtLeastUploadedOneFile()
            // ||
            // claimUploadListModel.filter(
            //   x => x.coverageDetailId === currentCoverageDetailId
            // ).length < 1
          ) {
            missingProvideBenefitDocumentAlert()
          } else {
            if (checkAtLeastUploadedOneFile()) {
              dispatch(pageDecrement())
            } else {
              atLeastUploadOneFileAlert()
            }
          }
        } else {
          //delete files
          //clear form data
          //clear dropzone
          let thisCoverageUploadedList = claimUploadListModel.filter(doc => {
            return doc.coverageDetailId === currentCoverageDetailId
          })

          let deleteMultipleFileArray = []

          thisCoverageUploadedList.forEach((UploadedItem, UploadedKey) => {
            let deleteFileInfo = {}
            deleteFileInfo.fName = UploadedItem.fileName
            deleteFileInfo.folderName = uiData.folderName
            deleteMultipleFileArray.push(deleteFileInfo)
          })

          API.apiPostRequest(
            "/Claim/ClaimDocsMultipleDelete",
            deleteMultipleFileArray,
            null
          ).then(response => {})

          dispatch(removeChosenedBenefit(currentCoverageDetailId))

          dispatch(pageDecrement())
        }

        dispatch(resetSelectDocument())
        break

      default:
        if (uiData.showDeclaration) {
          dispatch(controlDeclaration())
        } else {
          dispatch(pageDecrement())
        }
    }
  }

  const hideBackButton = () => {
    //return true is hide the Back Button
    if (isEditUpload) return true

    switch (pageNumber) {
      case Constants.policyInfoPageNumber:
        return true
      default:
    }
  }

  const hideNextButton = () => {
    //return true is hide the Next Button
    switch (pageNumber) {
      case Constants.benefitGroupPageNumber:
        return true
      case Constants.benefitPageNumber:
        return true
      case Constants.reviewPageNumber:
        return uiData.chosenedBenefits.length > 0 ? false : true

      default:
    }
  }

  const showSummaryButton = () => {
    switch (pageNumber) {
      case Constants.benefitGroupPageNumber:
        if (uiData.chosenedBenefits.length > 0) {
          return true
        }
        break
      default:
    }
  }

  const calculateTotalClaimAmount = () => {
    let totalClaimAmount = 0

    const copyOfChosenedBenefits = Object.assign([], chosenedBenefits)
    const copyOfClaimData = Object.assign([], claimData)

    copyOfChosenedBenefits.forEach(ChosenedItem => {
      switch (ChosenedItem.CoverageCode) {
        default:
          if (
            copyOfClaimData[ChosenedItem.Category][ChosenedItem.CoverageCode]
              .claimAmount
          ) {
            totalClaimAmount +=
              copyOfClaimData[ChosenedItem.Category][ChosenedItem.CoverageCode]
                .claimAmount
          }
          break
      }
    })

    return totalClaimAmount
  }

  return (
    <div
      className={
        "FooterClaimTravel container-fluid " +
        (pageNumber === Constants.submittedClaimPageNumber ? "hide" : "")
      }
    >
      <div className="row" style={{ margin: 0 }}>
        <Container className="FooterDiv">
          <div className={"BackBtnDiv " + (hideBackButton() ? "hide" : "")}>
            <button
              type="button"
              className="RectangleBtn text-center backBtnSummaryPage"
              onClick={(e) => {
                e.currentTarget.blur(); // remove focus immediately
                previousPage();
              }}
            >
              <i className="fa fa-angle-left" aria-hidden="true"></i> Back
            </button>
          </div>

          <div className={"NextBtnDiv " + (hideNextButton() ? "hide" : "")}>
            <button
              type="button"
              className="RectangleBtn text-center NextBtn"
              onClick={() => nextPage()}
            >
              {!uiData.showDeclaration ? "Next" : "Submit Claim"}
            </button>
          </div>

          {/* Skip button used in Benefit selection page to go to summary page */}
          <div className={"NextBtnDiv " + (showSummaryButton() ? "" : "hide")}>
            <button
              type="button"
              className="RectangleBtn text-center NextBtn"
              onClick={() => nextPage()}
            >
              No I don't - Skip
            </button>
          </div>

          <div
            className={
              "totalAmountDiv " +
              (pageNumber === Constants.reviewPageNumber &&
              calculateTotalClaimAmount() > 0
                ? ""
                : "hide")
            }
          >
            <span className="amount">
              <NumberFormat
                value={calculateTotalClaimAmount().toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$ "}
              />
            </span>{" "}
            <br />
            <span className="text">Total Claim Amount</span>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default FunctionalFooter
